/**
 * Texterkennung für den Elternbrief-Leser — die Dateien kommen **aus der
 * eigenen App**, nie von einem CDN (offline-first, und Foto wie Text bleiben
 * auf dem Gerät). `vite.config.ts` kopiert sie beim Bauen aus `node_modules`
 * nach `ocr/<Fassung>/` und liefert sie im Entwicklungsserver unter demselben
 * Pfad aus. Im Service-Worker-Precache liegen sie nicht (gut 5 MB, die jede
 * Installation mitzöge); der Service Worker legt sie beim ersten Lesen in
 * einen eigenen Cache (`OCR_CACHE`), danach geht es auch offline.
 *
 * Die Fassung steht im Pfad, damit der Server die Dateien unbefristet cachen
 * lassen kann. `ocrAssets.test.ts` prüft, dass sie zu den installierten Paketen
 * passt — wer tesseract.js anhebt, muss sie hier mitziehen.
 */

/** Fassung von tesseract.js und tesseract.js-core (beide gleich). */
export const OCR_VERSION = '7.0.0';
/** Sprachdaten: `@tesseract.js-data/deu`, Modell `4.0.0_best_int` (nur LSTM). */
export const OCR_LANG_MODEL = '4.0.0_best_int';
export const OCR_BASE = `/ocr/${OCR_VERSION}`;
export const OCR_CACHE = `kraftwerk-ocr-${OCR_VERSION}`;

/**
 * Veröffentlichter Name → Pfad in `node_modules`. Nur die LSTM-Kerne: Sie
 * genügen für `OEM.LSTM_ONLY` und sind kleiner; welcher geladen wird (ohne,
 * mit SIMD, mit Relaxed SIMD), entscheidet tesseract.js am Gerät — geladen
 * wird immer genau einer.
 */
export const OCR_FILES: Record<string, string> = {
  'worker.min.js': 'tesseract.js/dist/worker.min.js',
  'tesseract-core-lstm.wasm.js': 'tesseract.js-core/tesseract-core-lstm.wasm.js',
  'tesseract-core-simd-lstm.wasm.js': 'tesseract.js-core/tesseract-core-simd-lstm.wasm.js',
  'tesseract-core-relaxedsimd-lstm.wasm.js':
    'tesseract.js-core/tesseract-core-relaxedsimd-lstm.wasm.js',
  'deu.traineddata.gz': `@tesseract.js-data/deu/${OCR_LANG_MODEL}/deu.traineddata.gz`,
  'LICENSE-tesseract.js.txt': 'tesseract.js/LICENSE.md',
  'LICENSE-tesseract.js-core.txt': 'tesseract.js-core/LICENSE',
};
